import { LanguageCode } from 'enums';

export const PROFILE_SUBMENU_ID = {
  LANGUAGE: 'language',
  THEME: 'theme',
  PRIVACY_SECURITY: 'privacy_security'
} as const;

export const PROFILE_THEME_MENU_ID = {
  LIGHT: 'light',
  DARK: 'dark'
} as const;

export const PROFILE_LANGUAGE_MENU_ID = {
  EN: LanguageCode.EN,
  ES: LanguageCode.ES
} as const;

export const NAV_GROUP_COLLAPSED_STORAGE_KEY = 'nav_group_collapsed';
